import { render, staticRenderFns } from "./row.vue?vue&type=template&id=ded31938&"
import script from "./row.vue?vue&type=script&lang=js&"
export * from "./row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports